export class Constants {
  static contactIntake(): string {
    return '/contact';
  }
}
